import * as React from "react";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { Link, useLocation } from "react-router-dom";
import styles from "../../styles/common/navbar.module.css";
import { ArrowDownward, ArrowDropDown, Download } from "@mui/icons-material";
import { handleDownload } from "./NavBar";
interface NavBarGovernanceProps {
  buttonType: "Governance" | "DownloadGovernanceData" | "UTX";
  lightTheme?: boolean;
}

const NavBarGovernance = (props: NavBarGovernanceProps) => {
  const { buttonType = "Governance" } = props;
  const location = useLocation();

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      {buttonType === "Governance" && (
        <>
          <Button
            id="basic-button"
            aria-controls={open ? "basic-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
            onClick={handleClick}
            className={`${
              props.lightTheme
                ? styles.buttonContainerLight
                : styles.buttonContainer
            } ${
              location.pathname === "/funds" && styles.buttonContainerCurrent
            }  ${
              location.pathname === "/challenges" &&
              styles.buttonContainerCurrent
            }  ${
              location.pathname === "/proposers" &&
              styles.buttonContainerCurrent
            } ${
              location.pathname === "/analytics" &&
              styles.buttonContainerCurrent
            }`}
          >
            Governance <ArrowDropDown />
          </Button>
          <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{
              "aria-labelledby": "basic-button",
            }}
          >
            <Link to={`/funds`}>
              <MenuItem onClick={handleClose}>
                <Typography className={styles.linkItem}>Funds</Typography>
              </MenuItem>
            </Link>

            <Link to={`/challenges`}>
              <MenuItem onClick={handleClose}>
                <Typography className={styles.linkItem}>Challenges</Typography>
              </MenuItem>
            </Link>

            <Link to={`/proposals`}>
              <MenuItem onClick={handleClose}>
                <Typography className={styles.linkItem}>Proposals</Typography>
              </MenuItem>
            </Link>

            <Link to={`/proposers`}>
              <MenuItem onClick={handleClose}>
                <Typography className={styles.linkItem}>Proposers</Typography>
              </MenuItem>
            </Link>
            <Link to={`/analytics`}>
              <MenuItem onClick={handleClose}>
                <Typography className={styles.linkItem}>Analytics</Typography>
              </MenuItem>
            </Link>
          </Menu>
        </>
      )}
      {buttonType === "DownloadGovernanceData" && (
        <>
          <Button
            id="basic-button"
            aria-controls={open ? "basic-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
            onClick={handleClick}
            className={`${
              props.lightTheme
                ? styles.buttonContainerLight
                : styles.buttonContainer
            }`}
          >
            Governance Data <ArrowDropDown />
          </Button>
          <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{
              "aria-labelledby": "basic-button",
            }}
          >
            <MenuItem
              onClick={() => {
                handleClose();
                handleDownload("WolframGovernanceData");
              }}
            >
              <Download /> Wolfram Governance Data
            </MenuItem>
            <MenuItem
              onClick={() => {
                handleClose();
                handleDownload("CatalystProposalData");
              }}
            >
              <Download /> Catalyst Proposal Data
            </MenuItem>
          </Menu>
        </>
      )}
      {buttonType === "UTX" && (
        <>
          <Button
            id="basic-button"
            aria-controls={open ? "basic-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
            onClick={handleClick}
            className={`${
              props.lightTheme
                ? styles.buttonContainerLight
                : styles.buttonContainer
            } ${
              location.pathname === "/resources" &&
              styles.buttonContainerCurrent
            }  `}
          >
            UTXO Resources <ArrowDropDown />
          </Button>
          <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{
              "aria-labelledby": "basic-button",
            }}
          >
            <Link to={`/resources/glossary`}>
              <MenuItem onClick={handleClose}>
                <Typography className={styles.linkItem}>Glossary</Typography>
              </MenuItem>
            </Link>
            <Link to={`/resources/blockchain-archive`}>
              <MenuItem onClick={handleClose}>
                <Typography className={styles.linkItem}>
                  UTXO Blockchain Archive
                </Typography>
              </MenuItem>
            </Link>
            <Link to={`/resources/contact-list`}>
              <MenuItem onClick={handleClose}>
                <Typography className={styles.linkItem}>
                  UTXO Contact List
                </Typography>
              </MenuItem>
            </Link>
          </Menu>
        </>
      )}
    </>
  );
};

export default NavBarGovernance;
